// 신규 폰트 제보 폼의 라이선스 파일 첨부 UI.
//
// 별도 직접 업로드 없이, 네이티브 file input 그대로 폼과 함께 multipart 로 제출된다.
// 파일을 선택하면 드롭존을 숨기고 파일명 + 삭제 버튼을 보여준다.
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "uploadArea", "fileInfo", "fileName"];

  handleFileSelect = () => {
    const file = this.fileInputTarget.files[0];
    if (!file) {
      this.showUploadArea();
      return;
    }

    this.fileNameTarget.textContent = file.name;
    this.uploadAreaTarget.classList.add("hidden");
    this.fileInfoTarget.classList.remove("hidden");
  };

  removeFile = () => {
    // file input 은 value 를 빈 문자열로 두면 선택이 해제된다.
    this.fileInputTarget.value = "";
    this.fileNameTarget.textContent = "";
    this.showUploadArea();
  };

  showUploadArea = () => {
    this.fileInfoTarget.classList.add("hidden");
    this.uploadAreaTarget.classList.remove("hidden");
  };
}
